<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        icon="el-icon-plus"
        @click="open('add')"
      >添加</el-button>
      <el-button
        type="danger"
        size="mini"
        icon="el-icon-delete"
        @click="bulkDelete"
      >删除</el-button>
      <el-button
        type="success"
        size="mini"
        icon="el-icon-refresh"
        @click="getList()"
      >刷新</el-button>
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="showtabelData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      style="width: 1311px"
      height="calc(100vh - 240px )"
      size="mini"
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="awardNo" label="编号" width="100" />
      <el-table-column prop="awardName" label="名称" width="200" class="sort" />
      <el-table-column prop="grid1" label="宫格1" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid1_name_id ? scope.row.grid1_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid1_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid1_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid1_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="grid2" label="宫格2" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid2_name_id ? scope.row.grid2_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid2_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid2_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid2_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="grid3" label="宫格3" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid3_name_id ? scope.row.grid3_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid3_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid3_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid3_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="grid4" label="宫格4" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid4_name_id ? scope.row.grid4_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid4_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid4_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid4_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="grid5" label="宫格5" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid5_name_id ? scope.row.grid5_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid5_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid5_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid5_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="grid6" label="宫格6" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid6_name_id ? scope.row.grid6_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid6_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid6_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid6_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="grid7" label="宫格7" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid7_name_id ? scope.row.grid7_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid7_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid7_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid7_count }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="grid8" label="宫格8" width="200">
        <template slot-scope="scope">
          <div style="font-size: 12px">
            奖品：{{
              scope.row.grid8_name_id ? scope.row.grid8_name : "感谢参与"
            }}
          </div>
          <div style="font-size: 12px">中奖概率：{{ scope.row.grid8_win }}</div>
          <div style="font-size: 12px; color: #f56c6c">
            当前中奖次数 ：{{ scope.row.grid8_cur_count || 0 }}
          </div>
          <div style="font-size: 12px">
            最多中奖次数：{{ scope.row.grid8_count }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="status" label="是否启用" width="100">
        <template slot-scope="scope">
          <div :style="{ color: scope.row.status ? '#67C23A' : '#e74c3c' }">
            {{ scope.row.status ? "启用" : "禁用" }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" width="220">
        <template slot-scope="scope">
          {{
            $parseTime(new Date(scope.row.createdAt), "{y}-{m}-{d} {h}:{i}:{s}")
          }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="open('edit', scope.row)"
          >修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加编辑弹窗 -->
    <el-dialog
      :title="isEdit ? '修改' : '添加'"
      :visible.sync="dialogVisible"
      width="1200px"
      :close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" label-width="220px" size="mini">
        <el-form-item label="名称">
          <el-input
            v-model="formData.awardName"
            placeholder="请输入名称"
            style="width: 200px"
            size="mini"
          />
        </el-form-item>
        <div class="gridStyle">
          <el-form-item label="">
            <div style="display: flex; align-items: center">
              <div style="width: 200px">奖品</div>
              <div style="width: 200px">中奖概率%</div>
              <div style="width: 200px">最多中奖次数</div>
              <div style="width: 200px">图片</div>
            </div>
          </el-form-item>
          <el-form-item label="宫格1">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid1_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格1')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid1_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid1_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid1_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid1_img')"
              />
            </div>
          </el-form-item>
          <el-form-item label="宫格2">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid2_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格2')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid2_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid2_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid2_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid2_img')"
              />
            </div>
          </el-form-item>
          <el-form-item label="宫格3">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid3_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格3')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid3_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid3_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid3_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid3_img')"
              />
            </div>
          </el-form-item>
          <el-form-item label="宫格4">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid4_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格4')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid4_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid4_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid4_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid4_img')"
              />
            </div>
          </el-form-item>
          <el-form-item label="宫格5">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid5_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格5')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid5_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid5_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid5_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid5_img')"
              />
            </div>
          </el-form-item>
          <el-form-item label="宫格6">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid6_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格6')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid6_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid6_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid6_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid6_img')"
              />
            </div>
          </el-form-item>
          <el-form-item label="宫格7">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid7_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格7')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid7_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid7_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid7_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid7_img')"
              />
            </div>
          </el-form-item>
          <el-form-item label="宫格8">
            <div style="display: flex; align-items: center">
              <el-select
                v-model="formData.grid8_name_id"
                placeholder="请选择优惠券"
                clearable
                @change="changeGridName($event, '宫格8')"
              >
                <el-option
                  v-for="item in optionsActivityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-input
                v-model="formData.grid8_win"
                placeholder="请输入中奖概率1~100"
                style="width: 200px; margin: 0 8px"
                size="mini"
                type="number"
                max="100"
                min="1"
              />
              <el-input
                v-model="formData.grid8_count"
                placeholder="请输入最多中奖次数"
                style="width: 200px"
                size="mini"
                type="number"
                max="100"
                min="0"
              />
              <uploadPic
                ref="uploadPic"
                :my-url="formData.grid8_img"
                :width="30"
                :height="30"
                style="display: flex; align-items: center"
                @upLoadImage="upLoadImage($event, 'grid8_img')"
              />
            </div>
          </el-form-item>
        </div>

        <el-form-item label="是否启用">
          <el-radio v-model="formData.status" :label="0">禁用</el-radio>
          <el-radio v-model="formData.status" :label="1">启用</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button
            style="margin-right: 10px"
            @click="dialogVisible = false"
          >取消</el-button>
          <el-popconfirm
            title="确定添加？"
            @onConfirm="isEdit ? edit() : add()"
          >
            <el-button
              slot="reference"
              type="primary"
              class="edit-button"
            >保存</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import uploadPic from '@/components/Upload/UploadPic' // 引入单图片上传组件
// import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import newUploadImage from '@/components/Upload/newUploadImage' // 上传图片
import environment from '@/utils/environment'
// Default SortableJS
import Sortable from 'sortablejs'
import {
  getAwardManList,
  addAwardMan,
  updateAwardMan,
  removeAwardMan
} from '@/api/activity/awardMan.js'

import { getTicketManList } from '@/api/ticketMan.js'

import { parseTime } from '@/utils'
export default {
  name: 'Order',
  components: { uploadPic },
  data() {
    return {
      loading: false,
      total: 0,
      showtabelData: [], // 表单数据
      multipleSelection: [], // 选中项
      dialogVisible: false, // 弹窗标识
      formData: {
        awardName: '',
        grid1_name_id: '',
        grid1_name: '',
        grid1_img: '',
        grid1_win: 1,
        grid1_count: 1,

        grid2_name_id: '',
        grid2_name: '',
        grid2_img: '',
        grid2_win: 1,
        grid2_count: 1,

        grid3_name_id: '',
        grid3_name: '',
        grid3_img: '',
        grid3_win: 1,
        grid3_count: 1,

        grid4_name_id: '',
        grid4_name: '',
        grid4_img: '',
        grid4_win: 1,
        grid4_count: 1,

        grid5_name_id: '',
        grid5_name: '',
        grid5_img: '',
        grid5_win: 1,
        grid5_count: 1,

        grid6_name_id: '',
        grid6_name: '',
        grid6_img: '',
        grid6_win: 1,
        grid6_count: 1,

        grid7_name_id: '',
        grid7_name: '',
        grid7_img: '',
        grid7_win: 1,
        grid7_count: 1,

        grid8_name_id: '',
        grid8_name: '',
        grid8_img: '',
        grid8_win: 1,
        grid8_count: 1,

        status: 1
      }, // 选中项
      effectiveTime: [],
      isEdit: false,
      config: {
        UEDITOR_HOME_URL: '/ueditor/', // 需要令此处的URL等于对应 ueditor.config.js 中的配置。服务器
        autoHeightEnabled: false,
        initialFrameHeight: 500,
        initialFrameWidth: 700,
        maximumWords: 9999999,
        // 上传文件接口
        serverUrl: '/gw/admin/operate/uploadBanner',
        headers: { Authorization: localStorage.getItem('token') },
        imageActionName: 'uploadimage',
        imageAllowFiles: ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        imageUrlPrefix: '' /* 图片访问路径前缀 */,
        imagePathFormat: '',
        imageMaxSize: 1024 * 1000 * 10 // 单位B 10MB
      },
      sortable: null,
      optionsActivityList: []
    }
  },
  mounted() {
    this.getList()

    getTicketManList().then((res) => {
      console.log('22', res)
      if (res && res.length > 0) {
        this.optionsActivityList = res.map((item) => {
          return {
            label: item.name,
            value: item.id.toString()
          }
        })
      }
    })
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    toArrayEvent(item) {
      return [item]
    },
    // 图片上传回调
    upLoadImage(url, name) {
      if (name === 'grid1_img') this.formData.grid1_img = url
      if (name === 'grid2_img') this.formData.grid2_img = url
      if (name === 'grid3_img') this.formData.grid3_img = url
      if (name === 'grid4_img') this.formData.grid4_img = url
      if (name === 'grid5_img') this.formData.grid5_img = url
      if (name === 'grid6_img') this.formData.grid6_img = url
      if (name === 'grid7_img') this.formData.grid7_img = url
      if (name === 'grid8_img') this.formData.grid8_img = url
    },
    // 获取表单信息
    getList() {
      this.loading = true
      getAwardManList()
        .then((res) => {
          this.showtabelData = res
          this.total = res.total
        })
        .catch((err) => {
          this.$message.error(err || '服务器错误，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 关闭添加弹窗
    handleClose() {
      // console.log(11)
      this.active = {}
    },
    initData() {
      this.formData = {
        awardName: '',

        grid1_name_id: '',
        grid1_name: '',
        grid1_img: '',
        grid1_win: 1,
        grid1_count: 1,

        grid2_name_id: '',
        grid2_name: '',
        grid2_img: '',
        grid2_win: 1,
        grid2_count: 1,

        grid3_name_id: '',
        grid3_name: '',
        grid3_img: '',
        grid3_win: 1,
        grid3_count: 1,

        grid4_name_id: '',
        grid4_name: '',
        grid4_img: '',
        grid4_win: 1,
        grid4_count: 1,

        grid5_name_id: '',
        grid5_name: '',
        grid5_img: '',
        grid5_win: 1,
        grid5_count: 1,

        grid6_name_id: '',
        grid6_name: '',
        grid6_img: '',
        grid6_win: 1,
        grid6_count: 1,

        grid7_name_id: '',
        grid7_name: '',
        grid7_img: '',
        grid7_win: 1,
        grid7_count: 1,

        grid8_name_id: '',
        grid8_name: '',
        grid8_img: '',
        grid8_win: 1,
        grid8_count: 1,

        status: 1
      }
    },
    open(type, item) {
      console.log(type, item)
      this.initData()
      this.effectiveTime = []
      if (type == 'add') {
        this.isEdit = false
        setTimeout(() => {
          this.$refs.uploadPic.init('')
        }, 0)
        this.dialogVisible = true
      } else if (type == 'edit') {
        this.isEdit = true
        this.formData = { ...this.formData, ...item }
        this.effectiveTime = [
          this.formData.effectiveStartTime,
          this.formData.effectiveEndTime
        ]
        this.dialogVisible = true
      }
    },
    // 添加
    add() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.award5_name = this.optionsActivityList.find((item) => {
        return item.value === this.formData.award5
      })?.label
      this.formData.award10_name = this.optionsActivityList.find((item) => {
        return item.value === this.formData.award10
      })?.label
      this.formData.award15_name = this.optionsActivityList.find((item) => {
        return item.value === this.formData.award15
      })?.label

      console.log(this.formData)

      addAwardMan(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('添加成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 修改
    edit() {
      const [startTime, endTime] = this.effectiveTime
      this.formData.effectiveStartTime = parseTime(
        startTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.effectiveEndTime = parseTime(
        endTime,
        '{y}-{m}-{d} {h}:{i}:{s}'
      )
      this.formData.award5_name = this.optionsActivityList.find((item) => {
        return item.value === this.formData.award5
      })?.label
      this.formData.award10_name = this.optionsActivityList.find((item) => {
        return item.value === this.formData.award10
      })?.label
      this.formData.award15_name = this.optionsActivityList.find((item) => {
        return item.value === this.formData.award15
      })?.label
      updateAwardMan(this.formData)
        .then((res) => {
          this.getList()
          this.dialogVisible = false
          this.$message.success('修改成功')
        })
        .catch((err) => {
          this.$message.error(err)
        })
    },
    // 批量删除
    bulkDelete() {
      console.log(this.multipleSelection, 'this.multipleSelection')
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          roundButton: true
        })
          .then(() => {
            const ids = this.multipleSelection.map((item) => {
              return item.id
            })
            removeAwardMan({ ids })
              .then((res) => {
                this.$message.success('删除成功')
                this.getList()
              })
              .catch((err) => {
                this.$message.error(err)
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      } else {
        this.$message.warning('请勾选要删除的选项')
      }
    },
    changeGridName(event, title) {
      console.log('23', event, title)
      if (title === '宫格1') {
        this.formData.grid1_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
      if (title === '宫格2') {
        this.formData.grid2_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
      if (title === '宫格3') {
        this.formData.grid3_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
      if (title === '宫格4') {
        this.formData.grid4_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
      if (title === '宫格5') {
        this.formData.grid5_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
      if (title === '宫格6') {
        this.formData.grid6_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
      if (title === '宫格7') {
        this.formData.grid7_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
      if (title === '宫格8') {
        this.formData.grid8_name = this.optionsActivityList.find((item) => {
          return item.value === event
        })?.label
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head_search {
  display: flex;
  // justify-content: space-around;
  width: 100%;
  .item_warp {
    display: flex;
    .el-checkbox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #525252;
    }
  }
}
.role_warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
.isSyn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.gridStyle {
  background: #f9f9f9;
  padding: 10px 0 1px;
  box-sizing: border-box;
}
</style>
